export default __webpack_public_path__ + "static/media/mailinbox-12.aef2d6a9.svg";